import _styled from "styled-components";
import { css as _css } from "styled-components";
import React from "react";
import { Box } from "atomic-layout";
export var Container = function Container(props) {
  return /*#__PURE__*/React.createElement(_StyledBox, Object.assign({
    width: "calc(100% - 4px)",
    maxWidth: 1200,
    margin: "auto",
    paddingHorizontal: 16
  }, props));
};
var _StyledBox = _styled(Box).withConfig({
  displayName: "Container___StyledBox",
  componentId: "sc-chio9i-0"
})(["box-sizing:border-box;"]);